var map = {
	"./assistant.svg": 89184,
	"./broadcast-gymnastics.svg": 46208,
	"./camera.svg": 12669,
	"./clean.svg": 29139,
	"./copy.svg": 89911,
	"./delete.svg": 22681,
	"./doc.svg": 10,
	"./download.svg": 30192,
	"./draggable.svg": 35449,
	"./edit-3.svg": 55336,
	"./edit.svg": 37412,
	"./eraser.svg": 14656,
	"./female.svg": 94976,
	"./filter.svg": 15342,
	"./flag.svg": 58254,
	"./homework.svg": 26782,
	"./like.svg": 76129,
	"./like_on.svg": 20183,
	"./line-chart.svg": 71513,
	"./live.svg": 2462,
	"./male.svg": 38679,
	"./notify.svg": 55107,
	"./pause.svg": 51278,
	"./pen.svg": 36881,
	"./play.svg": 92190,
	"./remove.svg": 91752,
	"./school.svg": 31468,
	"./sent.svg": 25594,
	"./smart-phone.svg": 50448,
	"./student.svg": 28833,
	"./success.svg": 23873,
	"./teacher.svg": 82010,
	"./toolbox.svg": 64117,
	"./upload-1.svg": 88109,
	"./upload.svg": 78795,
	"./video.svg": 36193,
	"./warning.svg": 56428,
	"./workbench.svg": 13880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;